// Slug mappings (bidirectional)
export const SLUG_MAP_FR_TO_EN = {
  'depannage-crevaison-domicile-cannes': 'flat-tire-repair-home-service-cannes',
  'remplacement-pneus-express-alpes-maritimes': 'express-tire-replacement-alpes-maritimes',
  'extraction-ecrou-antivol-var': 'locking-wheel-nut-removal-var',
  'depannage-cle-vehicule-perdue': 'lost-car-key-roadside-assistance',
  'depannage-panne-batterie': 'car-battery-jump-start-replacement',
  'entretien-flottes-professionnelles': 'professional-fleet-tyre-maintenance',
};

export const SLUG_MAP_EN_TO_FR = Object.fromEntries(
  Object.entries(SLUG_MAP_FR_TO_EN).map(([fr, en]) => [en, fr])
);

// ─── English Services ────────────────────────────────────────────
export const SERVICES_EN = [
  {
    id: "crevaison",
    title: "Home Flat Tire Repair Service",
    shortDesc: "Got a flat tire? We come directly to your location to repair or replace your punctured tire. Express service available 7 days a week.",
    icon: "Disc3",
    image: "https://customer-assets.emergentagent.com/job_reco-pneus-preview/artifacts/58arfpho_d%C3%A9pannage%20crevaison%20a%20domicile.png",
    slug: "flat-tire-repair-home-service-cannes",
    benefits: [
      "Response within 45 minutes",
      "On-site repair or replacement",
      "Spare tyres available",
      "Service 7 days a week"
    ],
    faq: [
      {
        question: "How quickly can you respond to a flat tire call?",
        answer: "We typically arrive within 45 minutes in our priority zone (Cannes, Mandelieu-la-Napoule). For other areas in the Alpes-Maritimes and Var departments, allow up to 1 hour maximum."
      },
      {
        question: "Can you repair all types of punctures?",
        answer: "We repair the majority of punctures. If a repair isn't possible (damaged sidewall, puncture too large), we replace the tyre on site."
      },
      {
        question: "How much does a flat tire repair cost?",
        answer: "The price depends on the type of intervention (repair or replacement) and your location. Contact us for a free, instant quote."
      }
    ]
  },
  {
    id: "remplacement",
    title: "Express Tire Replacement",
    shortDesc: "Need new tyres fast? Same-day appointments guaranteed. We come to you with the right tyres for your vehicle.",
    icon: "RefreshCw",
    image: "https://images.unsplash.com/photo-1620707044570-c0dc1576bedd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMGNoYW5naW5nJTIwY2FyJTIwdGlyZSUyMHdoZWVsJTIwc2VydmljZXxlbnwwfHx8fDE3NzUyMjMyMjB8MA&ixlib=rb-4.1.0&q=85",
    slug: "express-tire-replacement-alpes-maritimes",
    benefits: [
      "Same-day appointment",
      "Wide range of brands",
      "Fitting and balancing included",
      "Competitive prices"
    ],
    faq: [
      {
        question: "Do you carry all tyre brands?",
        answer: "Yes, we work with all major brands: Michelin, Continental, Bridgestone, Pirelli, Goodyear, as well as quality budget alternatives."
      },
      {
        question: "Is fitting included in the price?",
        answer: "Absolutely! Our prices include the tyre, fitting, balancing, and valve. No hidden fees."
      },
      {
        question: "Can you come the same day?",
        answer: "Yes, we guarantee same-day service for requests received before 3 PM. Contact us to check availability."
      }
    ]
  },
  {
    id: "ecrou-antivol",
    title: "Locking Wheel Nut Removal",
    shortDesc: "Lost or damaged your locking wheel nut key? We have the professional tools to extract your locking nuts without damaging your alloys.",
    icon: "Key",
    image: "https://images.unsplash.com/photo-1764015805414-df7de89d405b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHx0aXJlJTIwcmVwbGFjZW1lbnQlMjBtZWNoYW5pY3xlbnwwfHx8fDE3NzUyMjE5MjZ8MA&ixlib=rb-4.1.0&q=85",
    slug: "locking-wheel-nut-removal-var",
    benefits: [
      "Damage-free extraction",
      "Professional tooling",
      "All vehicle makes",
      "New locking nuts supplied"
    ],
    faq: [
      {
        question: "Will the extraction damage my alloy wheels?",
        answer: "No, our professional equipment allows a clean extraction without damaging your wheels. We take every precaution necessary."
      },
      {
        question: "Do you supply new locking wheel nuts?",
        answer: "Yes, we can supply and fit a new set of locking wheel nuts after extraction. Several models available."
      },
      {
        question: "Do you work on all vehicle makes?",
        answer: "Yes, we work on all makes: cars, vans, SUVs. Our equipment covers all types of locking wheel nuts on the market."
      }
    ]
  },
  {
    id: "cle-perdue",
    title: "Lost Car Key Assistance",
    shortDesc: "Key lost, stolen, or locked inside your vehicle? Express on-site assistance to get you back on the road quickly.",
    icon: "KeyRound",
    image: "https://images.unsplash.com/photo-1761014586544-53fe5e1f1e25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjYXIlMjBrZXklMjBoYW5kJTIwaXNvbGF0ZWR8ZW58MHx8fHwxNzc1MjIzMjIwfDA&ixlib=rb-4.1.0&q=85",
    slug: "lost-car-key-roadside-assistance",
    benefits: [
      "Non-destructive entry",
      "Fast response",
      "All vehicle makes",
      "Immediate solution"
    ],
    faq: [
      {
        question: "Can you open my car without causing damage?",
        answer: "Yes, we use professional techniques and tools that allow us to open your vehicle without any damage."
      },
      {
        question: "Do you operate at night?",
        answer: "We operate from 9 AM to 7 PM, 7 days a week. For emergencies outside these hours, contact us to discuss options."
      },
      {
        question: "What if I've lost my only key?",
        answer: "We can open your vehicle and advise you on the steps to obtain a new key from the dealer or an automotive locksmith."
      }
    ]
  },
  {
    id: "batterie",
    title: "Car Battery Breakdown Service",
    shortDesc: "Dead battery? We respond quickly at your home or roadside to recharge or replace your battery. Get back on the road in minutes.",
    icon: "Battery",
    image: "https://images.unsplash.com/photo-1597766325363-f5576d851d6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjYXIlMjBiYXR0ZXJ5JTIwanVtcCUyMHN0YXJ0fGVufDB8fHx8MTc3NTIyMTkyNnww&ixlib=rb-4.1.0&q=85",
    slug: "car-battery-jump-start-replacement",
    benefits: [
      "Free diagnostics",
      "Recharge or replacement",
      "New batteries available",
      "Fast response"
    ],
    faq: [
      {
        question: "Can you recharge my battery on site?",
        answer: "Yes, we carry professional jump starters to get your vehicle running immediately. If the battery has reached end of life, we can replace it on the spot."
      },
      {
        question: "How do I know if my battery needs replacing?",
        answer: "We perform a free diagnostic during our visit. If the battery is still in good condition, a simple recharge will do. Otherwise, we'll offer a replacement."
      },
      {
        question: "Which battery brands do you carry?",
        answer: "We carry major brands (Bosch, Varta, Exide) as well as quality budget alternatives, all suited to your vehicle."
      }
    ]
  },
  {
    id: "flottes",
    title: "Professional Fleet Maintenance",
    shortDesc: "Dedicated service for businesses: tyre maintenance and mechanical servicing directly at your premises. Minimise vehicle downtime.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1587813369290-091c9d432daf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBmbGVldCUyMHZhbnMlMjB0cnVja3MlMjBtYWludGVuYW5jZSUyMHdvcmtzaG9wfGVufDB8fHx8MTc3NTIyMzg2MXww&ixlib=rb-4.1.0&q=85",
    slug: "professional-fleet-tyre-maintenance",
    benefits: [
      "On-site service",
      "Custom contracts",
      "Fleet tracking",
      "Preferential rates"
    ],
    faq: [
      {
        question: "Do you come directly to our premises?",
        answer: "Yes, that's our specialty! We travel to your site for fleet maintenance, minimising vehicle downtime."
      },
      {
        question: "Do you offer maintenance contracts?",
        answer: "Yes, we offer tailor-made contracts adapted to your fleet size and specific needs, with preferential rates."
      },
      {
        question: "What types of vehicles do you service?",
        answer: "We service all types of commercial vehicles: company cars, vans, light trucks, delivery vehicles, and more."
      }
    ]
  }
];

// ─── English SEO ─────────────────────────────────────────────────
export const SEO_EN = {
  home: {
    title: "Reco Pneus | Mobile Tire Repair & Roadside Assistance — Cannes, French Riviera",
    description: "Mobile tire repair and roadside assistance 7 days a week in the Alpes-Maritimes and Var. Flat tire, express tire replacement, battery, lost key. Fast response in Cannes, Nice, Antibes.",
    keywords: "mobile tire repair, flat tire emergency, express tire replacement, Cannes, French Riviera, Alpes-Maritimes, Var, battery breakdown, roadside assistance"
  }
};

// ─── UI Translations ─────────────────────────────────────────────
const UI = {
  fr: {
    lang: 'fr',
    // Header
    nav: {
      home: 'Accueil',
      services: 'Nos Services',
      reviews: 'Avis Clients',
      contact: 'Contact',
      quote: 'Demande de Devis',
    },
    callNow: 'Appeler maintenant',
    callNowShort: 'Appeler',
    menuOpen: 'Ouvrir le menu',
    menuClose: 'Fermer le menu',

    // Hero
    hero: {
      badge: 'Intervention 7j/7',
      headline1: 'Crevaison ?',
      headline2: 'On arrive.',
      subtitleHtml: 'Dépannage pneu à domicile dans les <strong class="text-[#41DB23]">Alpes-Maritimes</strong> et le <strong class="text-[#41DB23]">Var</strong>.',
      subtitleLine2: 'Intervention express pour particuliers et professionnels.',
      ctaQuote: 'Demander un devis',
      trust: [
        'Intervention rapide',
        'Devis immédiat par téléphone',
        'Disponible 7j/7',
        'Professionnels qualifiés',
        'Prestation dépannage remboursable par votre assurance',
        'English spoken',
      ],
    },

    // Services section
    servicesSection: {
      badge: 'Nos Services',
      title: 'Assistance pneumatiques & dépannage',
      subtitle: 'Intervention rapide dans les Alpes-Maritimes et le Var.',
      subtitleLine2: 'Particuliers et professionnels, nous avons la solution à votre problème.',
      callBtn: 'Appeler',
      moreBtn: 'En savoir plus',
      bottomCta: "Besoin d'une intervention urgente ?",
    },

    // Testimonials
    testimonials: {
      badge: 'Avis Clients',
      title: 'Ils nous font confiance',
      reviewSuffix: 'avis Google',
      viewAll: 'Voir tous les avis sur Google',
    },

    // Contact
    contact: {
      badge: 'Contact',
      title: 'Contactez-nous',
      subtitle: 'Intervention rapide dans les Alpes-Maritimes et le Var.',
      subtitleLine2: 'Appelez-nous ou envoyez-nous un message.',
      phoneLabel: 'Téléphone',
      clickToCall: 'Cliquez pour appeler',
      emailLabel: 'Email',
      hoursLabel: "Horaires d'intervention",
      areaLabel: "Zone d'intervention",
      areaDesc: "Nous intervenons sur l'ensemble des départements du Var et des Alpes-Maritimes.",
      bottomCta: 'Urgence ? Appelez-nous directement !',
      mapLegend: "Zone d'intervention",
      mapSea: 'Mer Méditerranée',
    },

    // Quote form
    form: {
      badge: 'Demande de Devis',
      title: 'Demandez un devis rapide',
      subtitle: 'Décrivez votre situation et nous vous recontacterons rapidement avec un devis personnalisé.',
      successTitle: 'Demande envoyée !',
      successMsg: 'Merci pour votre demande. Nous vous contacterons dans les plus brefs délais.',
      successBtn: 'Envoyer une nouvelle demande',
      nom: 'Nom',
      prenom: 'Prénom',
      nomPlaceholder: 'Votre nom',
      prenomPlaceholder: 'Votre prénom',
      telephone: 'Téléphone',
      telephonePlaceholder: '06 XX XX XX XX',
      email: 'Email',
      emailPlaceholder: 'votre@email.com',
      serviceLabel: 'Type de service souhaité',
      servicePlaceholder: 'Sélectionnez un service',
      other: 'Autre',
      messageLabel: 'Message / Description de la situation',
      messagePlaceholder: 'Décrivez votre situation, type de véhicule, localisation...',
      submitBtn: 'Envoyer ma demande',
      submitting: 'Envoi en cours...',
      privacyHtml: 'En soumettant ce formulaire, vous acceptez notre <a href="/politique-confidentialite" class="text-[#41DB23] hover:underline">politique de confidentialité</a>. Vos données sont traitées conformément au RGPD.',
      errorDefault: 'Une erreur est survenue. Veuillez réessayer.',
    },

    // Cookie banner
    cookies: {
      title: 'Utilisation des cookies',
      text: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant, vous acceptez notre',
      privacyLink: 'politique de confidentialité',
      cookieLink: 'politique de cookies',
      accept: 'Accepter',
      refuse: 'Refuser',
    },

    // Footer
    footer: {
      desc: 'Service de dépannage pneumatiques et assistance véhicule à domicile. Intervention rapide dans les Alpes-Maritimes et le Var. Particuliers et professionnels.',
      navTitle: 'Navigation',
      infoTitle: 'Informations',
      copyright: 'Tous droits réservés.',
      mentions: 'Mentions légales',
      privacy: 'Politique de confidentialité',
      cookiesLink: 'Cookies',
    },

    // Service Landing Page
    servicePage: {
      backHome: "Retour à l'accueil",
      serviceBadge: 'Service',
      whyChoose: 'Pourquoi choisir Reco Pneus ?',
      coverageBadge: "Zone d'intervention",
      coverageTitle: 'Nous intervenons près de chez vous',
      coverageDesc: (title) => `Service de ${title.toLowerCase()} dans les Alpes-Maritimes et le Var. Zone prioritaire : Cannes, Mandelieu-la-Napoule et 50km autour.`,
      faqBadge: 'FAQ',
      faqTitle: 'Questions fréquentes',
      finalCtaTitle: (title) => `Besoin d'un ${title.toLowerCase()} ?`,
      finalCtaDesc: 'Appelez-nous maintenant pour une intervention rapide dans les Alpes-Maritimes et le Var.',
      notFound: 'Service non trouvé',
      notFoundBtn: "Retour à l'accueil",
    },

    // SEO / Schema
    schemaServiceTypes: ["Dépannage pneu", "Remplacement pneumatiques", "Dépannage batterie", "Assistance routière"],
  },

  en: {
    lang: 'en',
    // Header
    nav: {
      home: 'Home',
      services: 'Our Services',
      reviews: 'Customer Reviews',
      contact: 'Contact',
      quote: 'Request a Quote',
    },
    callNow: 'Call now',
    callNowShort: 'Call',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',

    // Hero
    hero: {
      badge: 'Available 7 days a week',
      headline1: 'Flat tire?',
      headline2: "We're on our way.",
      subtitleHtml: 'Mobile tire repair across the <strong class="text-[#41DB23]">Alpes-Maritimes</strong> and <strong class="text-[#41DB23]">Var</strong> departments.',
      subtitleLine2: 'Express roadside assistance for individuals and businesses.',
      ctaQuote: 'Request a quote',
      trust: [
        'Fast response',
        'Instant phone quote',
        'Available 7/7',
        'Qualified professionals',
        'Repair costs reimbursable by your insurance',
        'We speak English',
      ],
    },

    // Services section
    servicesSection: {
      badge: 'Our Services',
      title: 'Tire assistance & roadside repair',
      subtitle: 'Fast response across the Alpes-Maritimes and Var.',
      subtitleLine2: 'Individuals and businesses — we have the solution to your problem.',
      callBtn: 'Call',
      moreBtn: 'Learn more',
      bottomCta: 'Need urgent assistance?',
    },

    // Testimonials
    testimonials: {
      badge: 'Customer Reviews',
      title: 'Trusted by our customers',
      reviewSuffix: 'Google reviews',
      viewAll: 'View all reviews on Google',
    },

    // Contact
    contact: {
      badge: 'Contact',
      title: 'Get in touch',
      subtitle: 'Fast response across the Alpes-Maritimes and Var.',
      subtitleLine2: 'Call us or send us a message.',
      phoneLabel: 'Phone',
      clickToCall: 'Click to call',
      emailLabel: 'Email',
      hoursLabel: 'Operating hours',
      areaLabel: 'Service area',
      areaDesc: 'We cover the entire Var and Alpes-Maritimes departments on the French Riviera.',
      bottomCta: 'Emergency? Call us now!',
      mapLegend: 'Service area',
      mapSea: 'Mediterranean Sea',
    },

    // Quote form
    form: {
      badge: 'Request a Quote',
      title: 'Get a quick quote',
      subtitle: 'Describe your situation and we will get back to you promptly with a personalised quote.',
      successTitle: 'Request sent!',
      successMsg: 'Thank you for your request. We will contact you as soon as possible.',
      successBtn: 'Send another request',
      nom: 'Last name',
      prenom: 'First name',
      nomPlaceholder: 'Your last name',
      prenomPlaceholder: 'Your first name',
      telephone: 'Phone',
      telephonePlaceholder: '+33 6 XX XX XX XX',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      serviceLabel: 'Desired service type',
      servicePlaceholder: 'Select a service',
      other: 'Other',
      messageLabel: 'Message / Describe your situation',
      messagePlaceholder: 'Describe your situation, vehicle type, location...',
      submitBtn: 'Send my request',
      submitting: 'Sending...',
      privacyHtml: 'By submitting this form, you agree to our <a href="/politique-confidentialite" class="text-[#41DB23] hover:underline">privacy policy</a>. Your data is processed in accordance with the GDPR.',
      errorDefault: 'An error occurred. Please try again.',
    },

    // Cookie banner
    cookies: {
      title: 'Cookie usage',
      text: 'We use cookies to improve your experience on our site. By continuing, you accept our',
      privacyLink: 'privacy policy',
      cookieLink: 'cookie policy',
      accept: 'Accept',
      refuse: 'Decline',
    },

    // Footer
    footer: {
      desc: 'Mobile tire repair and vehicle assistance service. Fast response across the Alpes-Maritimes and Var on the French Riviera. For individuals and businesses.',
      navTitle: 'Navigation',
      infoTitle: 'Information',
      copyright: 'All rights reserved.',
      mentions: 'Legal notices',
      privacy: 'Privacy policy',
      cookiesLink: 'Cookies',
    },

    // Service Landing Page
    servicePage: {
      backHome: 'Back to home',
      serviceBadge: 'Service',
      whyChoose: 'Why choose Reco Pneus?',
      coverageBadge: 'Service area',
      coverageTitle: 'We come to you',
      coverageDesc: (title) => `${title} service across the Alpes-Maritimes and Var. Priority zone: Cannes, Mandelieu-la-Napoule and surrounding 50 km.`,
      faqBadge: 'FAQ',
      faqTitle: 'Frequently asked questions',
      finalCtaTitle: (title) => `Need ${title.toLowerCase().replace(/^(home |express |professional )/, '')} help?`,
      finalCtaDesc: 'Call us now for a fast response anywhere in the Alpes-Maritimes and Var.',
      notFound: 'Service not found',
      notFoundBtn: 'Back to home',
    },

    // SEO / Schema
    schemaServiceTypes: ["Tire repair", "Tire replacement", "Battery service", "Roadside assistance"],
  },
};

export default UI;
